module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.users.listOfUsers')))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('div', {
    staticClass: "input-group input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchUsers),
      expression: "searchUsers"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "search",
      "name": "table_search",
      "placeholder": _vm.$t('pages.adminpanel.users.search')
    },
    domProps: {
      "value": (_vm.searchUsers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchUsers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getUsers(_vm.searchUsers)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.users.tableId')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.users.tableUser')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.users.tableRole')))]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.users), function(usr) {
    return _c('tr', {
      key: usr.id
    }, [_c('td', [_vm._v(_vm._s(usr.id))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "hoverRole",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showUserData(usr)
        }
      }
    }, [_vm._v(_vm._s(usr.firstName) + " " + _vm._s(usr.lastName))])]), _vm._v(" "), _c('td', [_vm._l((usr.implicitRoles), function(role) {
      return _c('span', [(role.name == 'admin.user') ? _c('div', {
        staticClass: "badge bg-red"
      }, [_vm._v(_vm._s(role.displayName))]) : (role.name == 'admin.group') ? _c('div', {
        staticClass: "badge bg-green"
      }, [_vm._v(_vm._s(role.displayName))]) : (role.name == 'admin.device') ? _c('div', {
        staticClass: "badge bg-blue"
      }, [_vm._v(_vm._s(role.displayName))]) : (role.name == 'admin') ? _c('div', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(role.displayName))]) : _vm._e()])
    }), _vm._v(" "), _c('a', {
      attrs: {
        "id": "addRole"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addNewRole(usr.id)
        }
      }
    }, [(usr.implicitRoles.length == 0) ? _c('div', {}) : _vm._e()])], 2), _vm._v(" "), _c('td', [(!usr.hasPassword) ? _c('a', {
      staticClass: "btn btn",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Resend invitation"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.resendInvite(usr.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-mail-forward"
    })]) : (false) ? _c('a', {
      staticClass: "btn btn",
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('i', {
      staticClass: "fa  fa-eye  "
    })]) : _vm._e(), _vm._v(" "), (usr.id != _vm.me.id) ? _c('a', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteUser(usr.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('nav', {
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('ul', {
    staticClass: "pagination pull-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('li', {
    staticClass: "page-item",
    class: [_vm.pagination.page === 1 ? 'disabled' : '']
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getUsers('', _vm.pagination.page - 1)
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _vm._l((_vm.getDisplayedPages(_vm.pagination.page)), function(result, index) {
    return _c('li', {
      staticClass: "page-item",
      class: [_vm.pagination.page === result + 1 ? 'active' : '']
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getUsers('', result + 1)
        }
      }
    }, [_vm._v(_vm._s(result + 1))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: [_vm.pagination.page === _vm.pagination.totalPageCount ? 'disabled' : '']
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getUsers('', _vm.pagination.page + 1)
      }
    }
  }, [_vm._v("Next")])])], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5dd75460", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dd75460"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users.vue
// module id = 1441
// module chunks = 1